import { Logger } from 'library/ts/utilities/logger/Logger';
import { LogLevels, LogMethods, LogMethodsLevelsMap } from 'library/ts/utilities/logger/LogServiceConstants';
import { getSmartTagRuntimeVO } from 'tag/ts/smart_tag/utilities/Runtime';
export class LogService {
    static get utils() {
        return window?.PARA?.PlayerServices?.Utilities;
    }
    static #timeStart = Date.now();
    static get timeStart() {
        return window.PARA?.PlayerServices?.StartTime || LogService.#timeStart;
    }
    static get timeElapsed() {
        return Date.now() - LogService.timeStart;
    }
    static #logLevel;
    static get logLevel() {
        if (!LogService?.utils?.Type?.isUndefined(LogService.#logLevel)) {
            return LogService.#logLevel;
        }
        if (LogService.runtimeVOLogLevel) {
            return LogService.#logLevel = +LogService.runtimeVOLogLevel;
        }
        return LogService.#logLevel = LogLevels.ERRORS_AND_INFO;
    }
    static #supportedMethods;
    static get supportedMethods() {
        if (LogService?.utils?.Type?.isUndefined(LogService.#supportedMethods)) {
            LogService.#supportedMethods = Object.keys(LogMethods).map((methodKey) => {
                return LogMethods[methodKey];
            });
        }
        return LogService.#supportedMethods;
    }
    static #availableMethods;
    static get availableMethods() {
        if (LogService?.utils?.Type?.isUndefined(LogService.#availableMethods)) {
            const currentLogLevel = LogService.logLevel;
            LogService.#availableMethods = LogService.supportedMethods.filter((logMethod) => {
                const methodLevel = LogMethodsLevelsMap?.[logMethod];
                return methodLevel >= currentLogLevel;
            });
        }
        return LogService.#availableMethods;
    }
    static methodIsAvailable(methodName) {
        return LogService.availableMethods.includes(methodName);
    }
    static #runtimeVOLogLevel;
    static get runtimeVOLogLevel() {
        return LogService.#runtimeVOLogLevel = LogService.#runtimeVOLogLevel || getSmartTagRuntimeVO()?.debug?.logLevel;
    }
    static get noOp() {
        return () => {
        };
    }
    static create = (options = {}) => {
        return new Logger(options);
    };
}
